import React, { useState } from 'react'
import TransactionTable from './component/TransactionTable'
import CustomPagination from 'components/molecules/CustomPagination'
import EmptyList from 'components/molecules/EmptyList'
import { useQuery } from 'react-query'
import { getTransactions } from 'api'
import { showErrorMessage } from 'utils'
import { getErrorMessage } from 'utils/getErrorMessage'
// Konfirmasi manual paket tertinggi dinonaktifkan sementara
// import { postManualSubscriptionApproval } from 'api'
// import { showSuccessMessage } from 'utils'
// import ManualSubscriptionApprovalModal from 'components/organisms/Modal/ManualSubscriptionApprovalModal'

const initialFilterTransaction = {
  page: 1,
  pageSize: 25,
  sort: 'created_at-'
}
// const initialApprovalModal = {
//   open: false,
//   data: null
// }
const Transaction = () => {
  const [filter, setFilter] = useState({
    ...initialFilterTransaction
  })
  // const [approvalModal, setApprovalModal] = useState({ ...initialApprovalModal })

  function updateFilter(key, value) {
    return setFilter((prev) => ({ ...prev, [key]: value }))
  }

  const { data: transactionList } = useQuery({
    queryKey: ['getTransactionsQuery', filter],
    queryFn: () => {
      let params = {
        page: filter.page,
        limit: filter?.pageSize,
        sort: filter?.sort
      }
      return getTransactions({ params })
    },
    onError: (err) => {
      return showErrorMessage(getErrorMessage(err))
    }
  })
  // const manualSubscriptionApprovalMutation = useMutation({
  //   mutationKey: 'postManualSubscriptionApproval',
  //   mutationFn: (payload) => postManualSubscriptionApproval(payload),
  //   onSuccess: (_, payload) => {
  //     showSuccessMessage(
  //       payload?.is_approve_flag ? 'Paket berhasil disetujui' : 'Paket berhasil ditolak'
  //     )
  //     handleCloseApprovalModal()
  //     refetch()
  //   },
  //   onError: (err) => {
  //     showErrorMessage(getErrorMessage(err))
  //   }
  // })

  // const handleOpenApprovalModal = (data) => {
  //   setApprovalModal({ open: true, data })
  // }
  // const handleCloseApprovalModal = () => {
  //   setApprovalModal({ ...initialApprovalModal })
  // }
  // const handleSubmitApproval = (isApprove) => {
  //   manualSubscriptionApprovalMutation.mutate({
  //     user_package_transaction_id: approvalModal?.data?.id,
  //     is_approve_flag: isApprove
  //   })
  // }

  // Handle pagination change
  const handlePageChange = (page) => {
    updateFilter('page', page)
  }
  // Handle pagination change
   const handlePageSizeChange = (pageSize) => {
      setFilter((prev) => ({ ...prev, pageSize, page: 1 }))
   }

  return (
    <div className="flex flex-col gap-8">
      <p className="text-2xl font-medium">Transaksi</p>
      {transactionList?.data?.length > 0 ? (
        <>
          <TransactionTable data={transactionList?.data ?? []} />
          <CustomPagination
            isShowPageSize
            totalData={transactionList?.meta?.total}
            pageSize={filter.pageSize}
            currentPage={filter.page}
            onPageSizeChange={handlePageSizeChange}
            onPaginationChange={handlePageChange}
          />
        </>
      ) : (
        <EmptyList category={'transaction'} />
      )}
      {/* {approvalModal.open && (
        <ManualSubscriptionApprovalModal
          open={true}
          packageName={approvalModal?.data?.package_name}
          isLoading={manualSubscriptionApprovalMutation.isLoading}
          onApprove={() => handleSubmitApproval(true)}
          onReject={() => handleSubmitApproval(false)}
          onClose={handleCloseApprovalModal}
        />
      )} */}
    </div>
  )
}

export default Transaction
